export enum EventName {
  JOIN_ROOM = 'JOIN_ROOM',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_STATUS_CHANGED = 'ORDER_STATUS_CHANGED',
}
